<div class="valg-tooltip" role="tooltip" [id]="id">
    {{ tooltip | translate }}
</div>